import React from 'react';

import styled from 'styled-components';

const MainButton = styled.div`
  width: fit-content;
  position: relative;
  text-transform: uppercase;
  border-radius: 45px;
  padding: ${({ $padding = '20px 25px' }) => $padding};

  font-weight: 500;
  font-size: ${({ $fontSize = '3rem' }) => $fontSize};

  cursor: pointer;

  overflow: hidden;

  span {
    position: relative;
    z-index: 1;
  }

  a {
    color: #fff;
    text-decoration: none;
    position: relative;
    z-index: 1;
    transition: 0.3s all ease-out;

    &:hover {
      text-shadow: 0px 0px 6px rgba(255, 255, 255, 0.9);
      -webkit-text-stroke: 1px rgba(255, 255, 255, 1);
    }
  }

  &::after {
    content: '';
    background: rgba(255, 255, 255, 0.12);
    position: absolute;
    inset: 0;
    filter: blur(15px);
    backdrop-filter: blur(24px);
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    padding: 1px;
    border-radius: 45px;
    background: linear-gradient(
      30deg,
      rgba(255, 255, 255, 0.8),
      rgba(255, 255, 255, 0)
    );
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }
`;

const Button = ({ padding, fontSize, dataButton = [], ...props }) => {
  return (
    <>
      <MainButton
        className="main-button"
        $padding={padding}
        $fontSize={fontSize}
      >
        {dataButton?.map((btn, index) => (
          <span key={index}>
            <a {...props} href={btn.link}>
              {btn.text}
            </a>
            {index < dataButton.length - 1 && ' / '}
          </span>
        ))}
      </MainButton>
    </>
  );
};

export default Button;
